module.exports = __webpack_public_path__ + "img/img1.c025ae04.png";